import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { font } from '../../styles/typography';

const TONE_COLOR = {
  info: 'var(--spark-color-info-text)',
  success: 'var(--spark-color-success-text)',
  warning: 'var(--spark-color-toast-warning)',
  danger: 'var(--spark-color-error-text)',
};

const Card = styled.div`
  background: ${(p) => (p.$tone === 'danger' ? 'var(--spark-color-error-surface)' : 'var(--spark-color-surface)')};
  border: 1px solid ${(p) => TONE_COLOR[p.$tone] || 'var(--spark-color-control-border)'};
  border-left: 5px solid ${(p) => TONE_COLOR[p.$tone] || 'var(--spark-color-control-disabled-text)'};
  border-radius: 10px;
  box-shadow: 0 8px 24px var(--spark-color-shadow-strong);
  padding: 12px 14px;
  color: var(--spark-color-text);
  animation: slide-in 160ms ease-out;
  @keyframes slide-in {
    from { transform: translateY(-8px); opacity: 0; }
    to { transform: none; opacity: 1; }
  }
`;

const Head = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
`;

const Title = styled.div`
  ${font('base')}
  font-weight: 700;
  color: ${(p) => TONE_COLOR[p.$tone] || 'var(--spark-color-text-secondary)'};
`;

const Body = styled.div`
  ${font('base')}
  margin-top: 4px;
`;

const Muted = styled.div`
  ${font('sm')}
  color: var(--spark-color-text-muted);
  margin-top: 2px;
`;

const CloseBtn = styled.button`
  border: 0;
  background: transparent;
  color: var(--spark-color-text-muted);
  cursor: pointer;
  ${font('lg')}
  line-height: 1;
  padding: 0 2px;
  &:hover { color: var(--spark-color-text-control); }
`;

const Actions = styled.div`
  display: flex;
  gap: 8px;
  margin-top: 10px;
`;

const Btn = styled.button`
  ${font('base')}
  border-radius: 6px;
  padding: 6px 12px;
  cursor: pointer;
  border: 1px solid var(--spark-color-action-primary);
  background: var(--spark-color-action-primary);
  color: var(--spark-color-on-action-primary);
  &:hover { background: var(--spark-color-action-primary-hover); }
`;

/**
 * Загальна плашка сповіщення (не дзвінок): заголовок, текст, підрядок, перехід кнопкою.
 * Перший споживач — замовлення prom.ua; форма `notice` — та сама, що для desktopNotify
 * (`{ key, title, body, line2, target, tone }`), щоб одна подія давала і тост, і системне сповіщення.
 */
export default function NoticeToast({ notice, onDismiss, onOpen }) {
  const navigate = useNavigate();
  return (
    <Card $tone={notice.tone || 'info'} role="status">
      <Head>
        <div>
          <Title $tone={notice.tone || 'info'}>{notice.title}</Title>
          {notice.body && <Body>{notice.body}</Body>}
          {notice.line2 && <Muted>{notice.line2}</Muted>}
        </div>
        <CloseBtn type="button" onClick={() => onDismiss(notice.key)} aria-label="Закрити">×</CloseBtn>
      </Head>
      {notice.target && (
        <Actions>
          <Btn type="button" onClick={() => { onDismiss(notice.key); navigate(notice.target); onOpen?.(); }}>{notice.actionLabel || 'Відкрити'}</Btn>
        </Actions>
      )}
    </Card>
  );
}
